import { ExclamationCircleIcon } from "@heroicons/react/24/outline";

export default function NoteField(props) {
  const {
    submitForm,
    setFieldValue,
    errors,
    touched,
    values,
    disabled = false,
  } = props;

  const handleSubmit = async () => {
    if (disabled) return;
    await submitForm();
    setFieldValue("note", ""); // Clear the field after submission
  };

  const handleKeyDown = async (e) => {
    if (disabled) return;
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault(); // Prevent default "Enter" key behavior
      await handleSubmit(); // Submit the form
    }
  };

  // Ensure textarea value is never null or undefined
  const noteValue = values && values["note"] != null ? values["note"] : "";

  return (
    <div className="flex items-start space-x-4 ">
      <div className="min-w-0 flex-1">
        <form action="#">
          <div className="relative">
            <div className="border-b border-gray-200 focus-within:border-blue-600">
              <label htmlFor="comment" className="sr-only">
                Add your comment
              </label>
              <textarea
                rows={2}
                name="note"
                id="note"
                disabled={disabled}
                className={`block w-full resize-none border-0 border-b border-transparent p-0 pb-2 pr-20 text-gray-900 placeholder:text-gray-400 focus:border-blue-400 focus:ring-0 sm:text-sm sm:leading-6 ${
                  disabled ? "opacity-50 cursor-not-allowed bg-gray-50" : ""
                }`}
                placeholder={disabled ? "Deaktivert" : "Skriv din kommentar..."}
                onChange={(e) => setFieldValue("note", e.target.value)}
                value={noteValue}
                onKeyDown={handleKeyDown} // Add onKeyDown event handler
              />
            </div>

            {/* Button positioned absolutely within the textarea area */}
            <div className="absolute bottom-2 right-0">
              <button
                onClick={handleSubmit}
                type="button"
                disabled={disabled}
                className={`inline-flex items-center px-2 py-1 text-xs font-medium text-blue-600 hover:text-blue-800 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:ring-offset-1 rounded transition-colors ${
                  disabled ? "opacity-50 cursor-not-allowed" : ""
                }`}
              >
                {disabled ? "Deaktivert" : "Legg til"}
              </button>
            </div>
          </div>

          {touched["note"] && errors["note"] && (
            <div className="flex mt-1 text-red-700 text-xs">
              <ExclamationCircleIcon className="w-4 text-xs" />
              <span className="ml-2">{errors["note"]}</span>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}
